import * as React from 'react';

import i18n from 'helper/i18n';
import { delayed } from 'lib/Job';

import UIAsset from 'components/atoms/UIAsset';

type NotificationPointsProps = {
	points: number;
	bonusPoints: number;
	onEventFinished: Function;
};

type NotificationPointsState = {
	mounted: boolean;
};

export default class NotificationPoints extends React.Component<NotificationPointsProps, NotificationPointsState> {
	public static displayName = 'NotificationPoints';

	public state = {
		mounted: false,
	};

	public shouldComponentUpdate() {
		return !this.state.mounted;
	}

	public componentDidMount() {
		this.handleAnimation();
	}

	public componentDidUpdate(prevProps: NotificationPointsProps) {
		if (this.props.points !== prevProps.points || this.props.bonusPoints !== prevProps.bonusPoints) {
			this.handleAnimation();
		}
	}

	public handleAnimation() {
		const { onEventFinished } = this.props;
		delayed(() => {
			this.setState({ mounted: true }, () => {
				delayed(() => {
					this.setState({ mounted: false }, () => {
						delayed(() => {
							onEventFinished();
						}, 150);
					});
				}, 2000);
			});
		}, 150);
	}

	public render() {
		const { points, bonusPoints } = this.props;

		return (
			<div
				className={`m-notification-points${this.state.mounted ? ' state-m-notification-points--visible' : ''}`}
			>
				<ul className="m-notification-points__box">
					{points !== 0 ? (
						<li key="points" className="m-notification-points__item">
							<span className="m-notification-points__value">
								<span className="m-notification-points__number">{points}</span>
							</span>
							<span className="m-notification-points__text">
								{i18n('react.impulsCoach.components.notificationPoints.points')}
							</span>
						</li>
					) : null}
					{bonusPoints !== 0 ? (
						<li key="bonuspoints" className="m-notification-points__item">
							<span className="m-notification-points__value">
								<span className="m-notification-points__flame">
									<UIAsset src="/img/svg/flame.svg" alt="" />
								</span>
								<span className="m-notification-points__plus">+</span>
								<span className="m-notification-points__number">{bonusPoints}</span>
							</span>
							<span className="m-notification-points__text">
								{i18n('react.impulsCoach.components.notificationPoints.bonusPoints')}
							</span>
						</li>
					) : null}
				</ul>
			</div>
		);
	}
}
